import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.red.darken2,
        secondary: colors.white,
        text: colors.black,
        background: colors.grey.lighten3,
        card1: colors.blue.lighten2,
        card2: colors.blue.lighten2,
        panel: colors.grey.lighten2,
        panelcontent: colors.grey.lighten1,
        button: colors.grey.lighten1
      },
      dark: {
        primary: colors.purple.darken2,
        secondary: colors.black,
        text: colors.white,
        background: colors.black,
        card1: colors.indigo,
        card2: colors.red.lighten1,
        panel: colors.grey.darken3,
        panelcontent: colors.grey.darken1,
        button: colors.grey.darken2
      }
    }
  }
})
